import { extractSubdomain } from './tenant.service'

// Kept apart from auth.service, which imports the app entry: the login page imports this
// module, and pulling the entry into its unit tests boots PostHog and metrics.
// Public, rate-limited endpoint: always answers 200 whether or not the email belongs to a
// staff user, so it can be called from the expired-link screen without leaking accounts.
// Minting the new link revokes every earlier one (Firebase keeps only the newest oobCode).
export const requestStaffPasswordReset = async (email) => {
  const baseUrl = import.meta.env.VITE_GATEWAY_URL || 'http://localhost:3002'
  const response = await fetch(`${baseUrl}/api/auth/staff/password-reset-request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-tenant': extractSubdomain() },
    body: JSON.stringify({
      email: email.toLowerCase(),
      continueUrl: `${window.location.origin}/reset-password`,
    }),
  })
  if (!response.ok) {
    const result = await response.json().catch(() => ({}))
    throw new Error(result.error || 'Failed to send password reset link')
  }
}
